import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "landing-wrapper" }

import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorOut',
  setup(__props) {


const router = useRouter()

function handleLogin() {
  router.push('/login')
}



return (_ctx: any,_cache: any) => {
  const _component_q2_text = _resolveComponent("q2-text")!
  const _component_q2_btn = _resolveComponent("q2-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q2_text, {
      class: "intro",
      variant: "body-sm"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("Sorry, for the ", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_q2_text, {
      class: "titleLogin",
      variant: "display-md"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode("Error!", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_q2_text, {
      class: "description",
      variant: "body-md"
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createTextVNode(" We've encountered an error. Please try again. ", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_q2_btn, {
      onClick: handleLogin,
      intent: "workflow-primary"
    }, {
      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createTextVNode(" Go to Login ", -1)
      ]))]),
      _: 1
    })
  ]))
}
}

})